import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { map } from 'rxjs/operators';

import { Subscription } from 'rxjs';
import { User } from '../_models/user.model';
import { EnvironmentService } from './environment.service';
import { Enhorario } from '../_models/en-horario.model';

@Injectable({
  providedIn: 'root'
})
export class HorarioService {
  isInhours : boolean = false;
  constructor(private http: HttpClient,
              private environmentService: EnvironmentService) {
  
  }

  getIsinhour(currentUser: User) : Promise<Enhorario> {
    //const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
    let grupo = "";
    switch (currentUser.TipoDeUsuario){
      case "Empresa":{
        grupo = "EMPRESA";
        break;
      }
      case "Afiliado":{
        grupo = "TRABAJADOR";
        break;
      }
      case "Windows":{
        grupo = "CAFAM";
        break;
      }
    }
    if (currentUser && currentUser.authToken) {
      const options = {
        headers: new HttpHeaders().append('Authorization', `Bearer ${currentUser.authToken}`)
      };
      return this.http
        .post<Enhorario>(`${this.environmentService.apiUrl}/Consultas/Horario?grupo=${grupo}`, options).toPromise();
    }
  }
}